import React from 'react';
import { cn } from "@/lib/utils";

const Logo = ({ className, size = "md", loading = false }) => {
    const sizes = {
        sm: "text-xl",
        md: "text-3xl",
        lg: "text-5xl",
        xl: "text-7xl"
    };

    return (
        <div
            className={cn(
                "inline-flex items-center font-extrabold tracking-tight select-none relative",
                sizes[size],
                className
            )}
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >
            <span style={{ color: "#acc8a2" }} className={cn(loading && "animate-pulse opacity-70")}>Home</span>
            <span style={{ color: "#1a2517" }} className={cn(loading && "animate-pulse")}>Ezi</span>

            {loading && (
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full animate-[shimmer_2s_infinite] pointer-events-none" />
            )}

            <style>{`
                @keyframes shimmer {
                    100% { transform: translateX(100%); }
                }
            `}</style>
        </div>
    );
};

export default Logo;
